const AudioConfig = {
    main: {
        src: '/audio/main/experience.mp3',
        volume: 0.4,  // Changed from 0.6
        fadeInDuration: 2000
    },
    unlock: {
        src: '/audio/unlock/revelation.mp3', // Now correct path
        volume: 0.3,  // Changed from 0.4
        duration: 1500
    },

    legacy: {
        src: '/audio/legacy/memories.mp3',
        volume: 0.35, // Changed from 0.5
        fadeInDuration: 2500
    }
};


export const setupAudio = (audioRef, track = 'main') => {
    const audioPath = AudioConfig[track].src;  // Use `src` instead of `path`
    console.log('Initializing audio with path:', audioPath);  // Debugging the path

    audioRef.current = new Audio(audioPath);
    audioRef.current.volume = AudioConfig[track].volume;
    audioRef.current.loop = true;
};

export const fadeAudio = (audioRef, direction, callback) => {
    const fade = setInterval(() => {
        if (direction === 'out' && audioRef.current.volume > 0.1) {
            audioRef.current.volume -= 0.1;
        } else if (direction === 'in' && audioRef.current.volume < AudioConfig.main.volume) {
            audioRef.current.volume += 0.1;
        } else {
            clearInterval(fade);
            if (callback) callback();
        }
    }, 100);
};